<mat-form-field appearance="outline" class="mb-2 chips-input-form-field w-full {{classList}}" (click)="$event.stopPropagation(); searchInput.focus()">
	<mat-label>{{label || placeholder}}</mat-label>
  <mat-chip-grid #chipList>
    <mat-chip-row
      tabindex="-1"
      class="max-w-full"
      *ngFor="let chip of chips"
      (removed)="removeItem(chip)">
      <span class="si-ui-chip__label" [matTooltip]="chip">{{ chip }}</span>
      <button tabindex="-1" matChipRemove>
        <fa-icon class="si-icon" [icon]="['fal', 'circle-xmark']"></fa-icon>
      </button>
    </mat-chip-row>

    <input
      type="text"
      autocomplete="off"
      #searchInput
      matInput
      [placeholder]="!chips.size ? placeholder : ''"
      [matChipInputFor]="chipList"
      (matChipInputTokenEnd)="addItem($event)"
      (input)="onSearchChange($event)"
      (keyup)="onSearchChange($event)"
    >
  </mat-chip-grid>
	<button *ngIf="showClear && chips.size" tabindex="-1" type="button" matSuffix matIconButton class="mr-1 clear-button mat-primary" (click)="clearAll()">
		<fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
	</button>
	<button *ngIf="showSearch" tabindex="-1" type="button" matSuffix mat-mini-fab class="mat-primary" [disabled]="!chips?.size" (click)="onSearch()" [ngClass]="{'pulse-button': showSearchPulseAnim && chips?.size}">
		<fa-icon class="si-icon" [icon]="['fal', 'magnifying-glass']"></fa-icon>
	</button>
</mat-form-field>
